import { FASTElement as u, attr as i } from "@microsoft/fast-element";
import { paginationStyles as f } from "./pagination.styles.js";
import { paginationTemplate as g } from "./pagination.template.js";
import d from "./pagination.i18n.js";
import { JsonValueConverter as c } from "../common/converters/json-value-converter.js";
import { NumberStringConverter as m } from "../common/converters/number-string-converter.js";
import { applyMixins as v } from "../common/apply-mixins.js";
import { PaginationMixin as b } from "./pagination-mixin.js";
import { designTokens as h } from "../design-tokens.js";
var y = Object.defineProperty, s = (p, o, n, _) => {
  for (var e = void 0, a = p.length - 1, l; a >= 0; a--)
    (l = p[a]) && (e = l(o, n, e) || e);
  return e && y(o, n, e), e;
};
const r = class r extends u {
  constructor() {
    super(...arguments), this.total = 0, this.page = 1, this.i18n = d, this.disabled = !1;
  }
  totalChanged() {
    this._input && this.updateInputWidth();
  }
  connectedCallback() {
    super.connectedCallback(), this.updateInputWidth(), this.size || (this.size = "md");
  }
  setPage() {
    if (!this._input.isValid) {
      this._input.value = this.page.toString();
      return;
    }
    this.page = Number(this._input.value), this.$emit("page", this.page, {
      cancelable: !1
    });
  }
  previousPage() {
    this.page > 1 && (this.page--, this.$emit("page", this.page, {
      cancelable: !1
    }));
  }
  nextPage() {
    this.page < this.total && (this.page++, this.$emit("page", this.page, {
      cancelable: !1
    }));
  }
  updateInputWidth() {
    this._input && (this._input.style.width = `var(${this.total > 99 ? h.spacing[12].cssCustomProperty : h.spacing[10].cssCustomProperty})`);
  }
};
r.definition = {
  name: "pagination",
  template: g,
  styles: f,
  attributes: ["size"]
};
let t = r;
s([
  i({ converter: m })
], t.prototype, "total");
s([
  i({ converter: m })
], t.prototype, "page");
s([
  i({ converter: c })
], t.prototype, "i18n");
s([
  i({ mode: "boolean" })
], t.prototype, "disabled");
v(t, b);
export {
  t as Pagination
};
